import * as React from 'react';
import styled from '@emotion/styled';
import { generatePath, Navigate, Route, Routes as RoutesSwitch } from 'react-router-dom';
import { observer } from 'mobx-react';
import { ProfileSecurityPage } from './security/ProfileSecurityPage';
import { Routes, SidebarItem, useJourneyNavigation } from '../../routes';
import { ProfileOrganizationsPage } from './ProfileOrganizationsPage';
import { PAGE_TITLE } from '../admin/AdminLandingPage';
import { ProfileTokensPage } from './ProfileTokensPage';
import { ProfileGeneralPage } from './ProfileGeneralPage';

export const ProfileSidebarItems: SidebarItem[] = [
  {
    label: 'Profile',
    key: Routes.PROFILE_GENERAL,
    path: Routes.PROFILE_GENERAL
  },
  {
    label: 'Security',
    key: Routes.PROFILE_SECURITY,
    path: Routes.PROFILE_SECURITY
  },
  {
    label: 'Organizations',
    key: Routes.PROFILE_ORGANIZATIONS,
    path: Routes.PROFILE_ORGANIZATIONS
  },
  {
    label: 'Access Tokens',
    key: Routes.PROFILE_TOKENS,
    path: Routes.PROFILE_TOKENS
  }
];

export const ProfileLandingPage: React.FC<{}> = observer(() => {
  const { relativeRoute, params } = useJourneyNavigation(Routes.PROFILE_HOME);

  React.useEffect(() => {
    document.title = PAGE_TITLE;
  }, []);

  return (
    <S.Container>
      <RoutesSwitch>
        <Route
          path={relativeRoute(Routes.PROFILE_HOME)}
          element={<Navigate replace={true} to={generatePath(Routes.PROFILE_GENERAL, params as any)} />}
        />
        <Route path={relativeRoute(Routes.PROFILE_GENERAL)} element={<ProfileGeneralPage />} />
        <Route path={relativeRoute(Routes.PROFILE_SECURITY)} element={<ProfileSecurityPage />} />
        <Route path={relativeRoute(Routes.PROFILE_ORGANIZATIONS)} element={<ProfileOrganizationsPage />} />
        <Route path={relativeRoute(Routes.PROFILE_TOKENS)} element={<ProfileTokensPage />} />
      </RoutesSwitch>
    </S.Container>
  );
});

namespace S {
  export const Container = styled.div`
    height: 100%;
    width: 100%;
  `;
}
